// Profile API surface (spec #41).
import { fetchJson } from './http';
import type { UserProfile } from './types';

export const userApi = {
  async me(getToken: () => string | null) {
    const data = await fetchJson<{ user: UserProfile }>('/users/me', getToken);
    return data.user;
  },

  async updateProfile(getToken: () => string | null, patch: { username?: string; bio?: string }) {
    const data = await fetchJson<{ user: UserProfile }>('/users/me', getToken, {
      method: 'PATCH',
      body: patch,
    });
    return data.user;
  },

  async deleteMe(getToken: () => string | null) {
    await fetchJson('/users/me', getToken, { method: 'DELETE' });
  },
};
